"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var owa_session_store_1 = require("owa-session-store");
var assign = require('object-assign');
exports.default = satcheljs_1.mutatorAction('updateSessionSettings', function updateSessionSettings(newSessionSettings) {
    assign(owa_session_store_1.getUserConfiguration().SessionSettings, newSessionSettings);
});
//# sourceMappingURL=updateSessionSettings.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/mutators/updateSessionSettings.js
// module id = 1831
// module chunks = 2 39 105 108